import { toDateString } from '@/munio/utils/date'
import { Api } from '@/munio/api/base'
import {
  CollectionResponse,
  SessionRequestResourceDto,
  SessionResourceDto,
  UserInviteResourceDto,
} from '@/munio/api/data'
import { CourseResourceDto, UserCourseResourceDto } from '@/munio/api/data/user'

type CoursesResponse = CollectionResponse<UserCourseResourceDto> & {
  invites: UserInviteResourceDto[]
  sessionRequests: SessionRequestResourceDto[]
  hostingSessions: SessionResourceDto[]
}

class CurrentUserCourses extends Api {
  get() {
    return this.$get<CoursesResponse>(this.$route('api.web.user.courses'))
  }

  enrollable() {
    return this.$get<CollectionResponse<CourseResourceDto>>(this.$route('api.web.user.courses.enrollable'))
  }

  id(id: number) {
    return new UserCourse(id)
  }
}

class UserCourse extends Api<{ course: number }> {
  constructor(id: number) {
    super({ course: id })
  }

  get(contextCompanyId?: number) {
    return this.$get(this.$route('api.web.user.course', { context: contextCompanyId as number }))
  }

  launch(contextCompanyId?: number, restart = false) {
    let url = this.$route('api.web.user.course.launch', { context: contextCompanyId as number })

    return this.$post(url, { restart })
  }

  restart() {
    return this.$post(this.$route('api.web.user.course.restart'))
  }

  enroll() {
    return this.$post(this.$route('api.web.user.course.enroll'))
  }

  unenroll() {
    return this.$post(this.$route('api.web.user.course.unenroll'))
  }

  document(file: File) {
    return this.$post(
      this.$route('api.web.user.course.document'),
      { document: file },
      {
        'content-type': 'multipart/form-data',
      },
    )
  }

  setdate(from: Date, to: Date) {
    return this.$post(this.$route('api.web.user.course.setdate'), {
      from: toDateString(from),
      to: toDateString(to),
    })
  }

  approve() {
    return this.$post(this.$route('api.web.user.course.approve'))
  }
}

export default CurrentUserCourses
